const numbersFields1 = document.querySelectorAll('[data-num]');
const numbersFields2 = document.querySelectorAll('input[type="number"]');
const numbersFields = [...numbersFields1, ...numbersFields2];

numbersFields.forEach((input) => {
	input.addEventListener('input', (event) => {
		const inputValue = event.target.value;
		event.target.value = inputValue.replace(/(?!^\+)\D/g, '');
	});
});
